<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="ml-2 mr-2">
      <validation-observer ref="interbankPaymentRules">
        <b-form
          id="gateway-fee-configuration"
          @submit.prevent="handleSubmit"
        >
          <b-row>
            <b-col
              cols="12"
            >
              <h5 class="section-label mt-2">
                {{ $t('Activate/ Deactivate Inward & Outward Transfers') }}
              </h5>
              <p
                class="text-muted mb-2"
                style="font-size: 12px;"
              >
                {{ $t('NOTE: This action will affects both Inward and Outward') }}
              </p>
              <b-row class="match-height">
                <b-col
                  cols="12"
                >
                  <SwitchButton
                    v-model="interbankPaymentFormData.isActive"
                    :label="$t('Interbank Payment')"
                    name="enable-interbank-payment"
                    class="ml-6"
                    :readonly="isReadonly"
                  />
                </b-col>
                <div class="ml-2 mt-2">
                  <Button
                    v-if="getUserPermission('ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER')"
                    :label="$t('Update')"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    size="lg"
                    @click="handleSubmit"
                  />
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol,
  BForm, VBTooltip,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import {
  required, amount, positive,
} from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import SwitchButton from '../../../../components/switch/Switch.vue'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    FullScreenSpinner,
    SwitchButton,
    Button,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      showSpinner: false,
      isDisabled: false,
      isLoading: false,
      required,
      amount,
      positive,
      buttonLabel: this.$t('Activate'),
      interbankPaymentFormData: {
        isActive: true,
      },
    }
  },
  mounted() {
    this.fetchInterBankPaymentStatus()
  },
  methods: {
    ...mapActions({
      getInterBankPaymentStatus: 'eChannels/getInterBankTransferStatus',
      updateInterBankPayment: 'eChannels/updateIntitutionGateway',
    }),

    handleSubmit() {
      this.buttonLabel = this.interbankPaymentFormData.isActive ? this.$t('Activate') : this.$t('Deactivate')
      this.$refs.interbankPaymentRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const text = this.$t('Interbank Payment?')
          this.confirm(this.interBankPaymentAction, { text: `${areYouSure} ${this.buttonLabel} ${text}` })
        }
      })
    },
    async interBankPaymentAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          isActive: this.interbankPaymentFormData.isActive === true,
        }
        const response = await this.updateInterBankPayment({ formData, permission: eChannelsPermission.ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER })

        const { status } = await response
        if (status === 200) {
          this.fetchInterBankPaymentStatus()
          const requestText = this.$t('Your request to')
          const successText = this.$t('Interbank Payment was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${successText}` })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('Interbank Payment failed. Reason')
          const errorMessage = `${requestText} ${this.buttonLabel} ${reasonText}: ${responseError.errorMessage}`
          this.alertError({ text: errorMessage })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async fetchInterBankPaymentStatus() {
      try {
        this.showSpinner = true
        const response = await this.getInterBankPaymentStatus({ permission: eChannelsPermission.ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER })
        const { status, data } = await response
        if (status === 200 && data) {
          this.interbankPaymentFormData = {
            isActive: data.isActive === true,
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>
